import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const JobPostsMatchesCard = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '320px',
    height: 'max-content',
    backgroundColor: 'transparent',
    borderRadius: '24px',
    position: 'sticky',
    top: '24px',

    [theme.breakpoints.down('laptop')]: {
      position: 'absolute',
      width: '100%',
      bottom: 0,
      left: '50%',
      top: 'initial',
      transform: 'translateX(-50%)',
      borderRadius: '24px 24px 0 0',
      boxShadow: '0 -4px 8px rgba(0, 0, 0, 0.1)',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      borderRadius: '0',
      left: '0',
      transform: 'translateX(0)',
    },
  };
});

export const JobPostsMatchesCard2 = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '320px',
    height: 'max-content',
    backgroundColor: palette.white,
    padding: '20px',
    borderRadius: '24px',
    /* position: 'sticky',
    top: '24px', */

    [theme.breakpoints.down('laptop')]: {
      position: 'absolute',
      width: '100%',
      bottom: 0,
      left: '50%',
      top: 'initial',
      transform: 'translateX(-50%)',
      borderRadius: '24px 24px 0 0',
      boxShadow: '0 -4px 8px rgba(0, 0, 0, 0.1)',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      borderRadius: '0',
      left: '0',
      transform: 'translateX(0)',
    },
  };
});

export const JobPostsMatchesCardHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  };
});

export const JobPostsMatchesCardHeaderTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '128%',
    whiteSpace: 'pre-line',
  };
});

export const JobPostsMatchesCardHeaderResults = styled(Typography)(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    color: palette.text.body,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '136%',
    letterSpacing: '0px',
  };
});

export const JobPostsMatchesCardMain = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '13px',
  };
});

export const JobPostsMatchesCardItem = styled(Box)<{ selected: any }>(({ selected }) => {
  return {
    width: '100%',
    height: 'max-content',
    backgroundColor: '#F3F6FF',
    borderRadius: '12px',
    padding: '16px',
    border: selected ? '1px solid #5D2F89' : '1px solid transparent',
    cursor: selected ? 'not-allowed' : 'pointer',
    pointerEvents: selected ? 'none' : 'initial',

    '&:hover': {
      borderColor: '#5D2F89',
    },
  };
});

export const CandidateListItemHeadingInfo = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
  };
});

export const CandidateListItemHeadingInfoTexts = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: 'calc(100% - 80px)',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  };
});

export const CandidateListItemHeadingInfoTitle = styled(Typography)(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '130%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '> span': {
      color: palette.text.placeholder,
      fontWeight: 500,
    },
  };
});

export const CandidateListItemHeadingInfoSalary = styled(Typography)(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    color: palette.text.header,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '128%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
});

export const SeeMoreJobs = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',

    '> p': {
      color: '#663497',
      fontWeight: 600,
      fontSize: '17px',
      lineHeight: '128%',
    },
  };
});

export const JobPostsMatchesCard2Header = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  };
});

export const JobPostsMatchesCard2HeaderTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '130%',
    whiteSpace: 'pre-line',
  };
});

export const JobPostsMatchesCard2HeaderDesc = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: '#444444',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '136%',
    whiteSpace: 'pre-line',
  };
});

export const FeedbackContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    backgroundColor: '#FFF1F1',
    borderRadius: '12px',
    padding: '16px',
  };
}) as typeof Box;

export const FeedbackContentItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    '> svg': {
      flexShrink: 0,
    },
  };
}) as typeof Box;
